import { render, staticRenderFns } from "./BusinessDistrictRanking.vue?vue&type=template&id=2c478220&scoped=true"
import script from "./BusinessDistrictRanking.vue?vue&type=script&lang=js"
export * from "./BusinessDistrictRanking.vue?vue&type=script&lang=js"
import style0 from "./BusinessDistrictRanking.vue?vue&type=style&index=0&id=2c478220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c478220",
  null
  
)

export default component.exports